import { useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";

const { innerHeight: height } = window;

const RackModelStore = () => {
  const navigate = useNavigate();

  const { userProfileRole } = getUserData();

  const userRole = userProfileRole;

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Rack Model
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-1">
        <div className="flex flex-1 flex-row">
          <div
            className="flex flex-1 flex-column justify-content-center align-items-center cursor-pointer"
            onClick={() => navigate("/RackAutoModel")}
            style={{ flex: 1, alignSelf: "center" }}
          >
            <img
              src={"warehouse/warehouse_2.png"}
              style={{
                alignSelf: "center",
                transform: [{ scaleX: 1 }],
                resizeMode: "contain",
                width: height < 600 ? "17%" : "20%",
              }}
            />
            <div className="my-3">
              <p className="text-4xl font-bold" style={{ color: "#2B70D7" }}>
                Auto Rack
              </p>
            </div>
          </div>

          {userRole === "BY_STORE" && (
            <div
              className="my-5 flex flex-1 flex-column justify-content-center align-items-center cursor-pointer"
              onClick={() => navigate("/RackManualModel")}
              style={{ display: "flex", flex: 1, alignSelf: "center" }}
            >
              <img
                src={"warehouse/warehouse_5.png"}
                style={{
                  alignSelf: "center",
                  transform: [{ scaleX: 1 }],
                  resizeMode: "contain",
                  width: height < 600 ? "17%" : "20%",
                }}
              />
              <div className="my-3">
                <p className="text-4xl font-bold" style={{ color: "#2B70D7" }}>
                  Manual Rack
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RackModelStore;
